module.exports = __webpack_public_path__ + "img/SSE_logo.7fefe623.png";